// <script>
var bus = require('com/js/bus');
module.exports = {
    ready: function() {
        // 监听 异步加载开始事件 展示loading
        bus.$on('begin-async', () => {
            this.show = true;
        });

        // 监听 异步结束事件 隐藏loading
        bus.$on('over-async', () => {
            this.show = false;
        })
    },

    data:function(){
        return {
            show: false
        }
    }
}
// </script>
//
//
//
// <template>
//     <div class="async-load" v-if="show">
//         <div class="back-block">
//             <div class="roting"></div>
//         </div>
//     </div>
// </template>
//
//
// <style lang="sass"  scoped>
//     .async-load {
//         position: absolute;
//         overflow: hidden;
//         z-index: 100000;
//         left: 0;
//         right: 0;
//         top: 0;
//         bottom: 0;
//         background: rgba(0,0,0,0.40);
//
//         .back-block {
//             position: absolute;
//             left: 50%;
//             top: 50%;
//
//             width: 220px;
//             height: 204px;
//             margin-left: -110px;
//             margin-top: -102px;
//
//             background: rgba(0,0,0,0.80);
//             border-radius: 2px;
//             .roting {
//                 position: absolute;
//                 left: 50%;
//                 top: 50%;
//
//                 width: 40px;
//                 height: 40px;
//                 margin-left: -20px;
//                 margin-top: -20px;
//
//                 background: url(./img/rotate.png) no-repeat center;
//
//                 animation: rotate 0.8s infinite linear;
//
//             }
//         }
//     }
//
//     @keyframes rotate {
//         0% { transform: rotate(0)}
//
//         100% {transform: rotate(-360deg)}
//     }
//
// </style>
//
/* generated by vue-loader */



// WEBPACK FOOTER //
// ./src/component/async_loading/async_loading.vue